import { motion } from "framer-motion";
import styled from "styled-components";
import { ReactComponent as PaymentAccept } from "../../assets/icons/banka.svg";

export const CheckoutWrapper = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem 0;
`;

export const CheckoutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  z-index: 3;
`;

export const OblacicDecoration = styled(motion.img)`
  position: absolute;
  z-index: 1;

  pointer-events: none;
  max-width: ${(props) => props.$size || "8rem"};
  width: 100%;
  height: auto;
  top: ${(props) => props.$top || "20%"};
  left: ${(props) => props.$left || "auto"};
  right: ${(props) => props.$right || "auto"};
  transform: rotate(${(props) => props.$rotate || "0deg"});
  opacity: ${(props) => props.$opacity || "0.6"};
  filter: blur(${(props) => props.$blur || "0px"});

  @media (max-width: 768px) {
    max-width: ${(props) => props.$mobileSize || "5rem"};
  }
`;

export const CheckoutHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 3rem;

  background: linear-gradient(
    135deg,
    rgba(240, 247, 248, 0.6) 0%,
    rgba(255, 255, 255, 0.9) 100%
  );
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(46, 100, 143, 0.12);
  border: 1px solid rgba(46, 100, 143, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--bg-plava), var(--plava));
    z-index: 2;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const CheckoutTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--bg-plava);
  margin: 0 0 0.5rem 0;
`;

export const CheckoutSubtitle = styled.p`
  font-size: 1.6rem;
  color: #666;
  margin: 0;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: rgba(46, 100, 143, 0.08);
  border: 1px solid rgba(46, 100, 143, 0.1);
  color: var(--bg-plava);
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.5s ease;
    z-index: 1;
  }

  &:hover::before {
    left: 100%;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  &:hover {
    background: rgba(46, 100, 143, 0.12);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(46, 100, 143, 0.15);
  }
`;

export const CheckoutContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const CheckoutForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const CheckoutSidebar = styled.div`
  position: sticky;
  top: 2rem;
  height: fit-content;
`;

export const QuantityBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  padding: 0.2rem 0.8rem;

  background: linear-gradient(
    135deg,
    rgba(46, 100, 143, 0.1),
    rgba(46, 100, 143, 0.2)
  );

  color: var(--bg-plava);

  font-size: 1.2rem;
  font-weight: 700;

  border-radius: 8px;
  border: 1px solid rgba(46, 100, 143, 0.25);
`;

export const FormSection = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(46, 100, 143, 0.08);
  border: 1px solid rgba(46, 100, 143, 0.1);
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--bg-plava), var(--plava));

    border-radius: 20px 20px 0 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: var(--bg-plava);
  margin: 0 0 2rem 0;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(46, 100, 143, 0.1);
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FormLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--bg-plava);
`;

export const FormInput = styled.input`
  padding: 1rem 1.2rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  font-family: inherit;
  background-color: white;
  color: var(--bg-plava);
  border: 1px solid
    ${(props) => (props.$error ? "#dc3545" : "rgba(46, 100, 143, 0.15)")};

  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  transition:
    border-color 0.3s,
    box-shadow 0.3s,
    background-color 0.3s,
    transform 0.3s;

  &::placeholder {
    color: rgba(46, 100, 143, 0.5);
  }

  &:focus {
    border: 1px solid var(--bg-plava) !important;
    box-shadow:
      0 0 0 4px rgba(0, 98, 154, 0.12),
      0 8px 25px 0 rgba(0, 98, 154, 0.15),
      0 4px 10px 0 rgba(0, 0, 0, 0.08) !important;
    outline: none;
    background-color: #fafbff !important;
    transform: translateY(-2px) !important;
  }

  &:hover {
    border: 1px solid var(--bg-plava);
    box-shadow:
      0 2px 8px 0 rgba(0, 98, 154, 0.08),
      0 1px 3px 0 rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      border: 1px solid rgba(46, 100, 143, 0.15);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
      transform: translateY(0);
    }
  }
`;

export const FormSelect = styled.select`
  padding: 1rem 1.2rem;
  border: none;
  border-radius: 1rem;
  width: 100%;
  font-size: 1.4rem;
  font-family: inherit;
  background-color: white;
  color: var(--bg-plava);
  border: 1px solid
    ${(props) => (props.$error ? "#dc3545" : "rgba(46, 100, 143, 0.15)")};

  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  transition:
    border-color 0.3s,
    box-shadow 0.3s,
    background-color 0.3s,
    transform 0.3s;

  &::placeholder {
    color: rgba(46, 100, 143, 0.5);
  }

  &:focus {
    border: 1px solid var(--bg-plava) !important;
    box-shadow:
      0 0 0 4px rgba(0, 98, 154, 0.12),
      0 8px 25px 0 rgba(0, 98, 154, 0.15),
      0 4px 10px 0 rgba(0, 0, 0, 0.08) !important;
    outline: none;
    background-color: #fafbff !important;
    transform: translateY(-2px) !important;
  }

  &:hover {
    border: 1px solid var(--bg-plava);
    box-shadow:
      0 2px 8px 0 rgba(0, 98, 154, 0.08),
      0 1px 3px 0 rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      border: 1px solid rgba(46, 100, 143, 0.15);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
      transform: translateY(0);
    }
  }
`;

export const SelectWrapper = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 1.2rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--bg-plava);
    font-size: 1.2rem;
    pointer-events: none;
    z-index: 1;
  }
`;

export const FormTextarea = styled.textarea`
  padding: 1.2rem;
  border: 1px solid rgba(46, 100, 143, 0.15);
  border-radius: 12px;
  font-size: 1.4rem;
  font-family: inherit;
  background: rgba(46, 100, 143, 0.03);
  resize: vertical;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--bg-plava);
    box-shadow: 0 0 0 3px rgba(46, 100, 143, 0.1);
    background: rgba(46, 100, 143, 0.05);
  }

  &::placeholder {
    color: rgba(46, 100, 143, 0.6);
  }
`;

export const PaymentAcceptIcon = styled(PaymentAccept)`
  height: 30px;

  width: 100%;
  margin-top: 3rem;
  align-self: center;
`;

export const PaymentMethods = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const PaymentMethod = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid rgba(46, 100, 143, 0.1);
  border-radius: 12px;
  background: rgba(46, 100, 143, 0.02);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(46, 100, 143, 0.05),
      transparent
    );
    transition: left 0.5s ease;
    z-index: 1;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    border-color: rgba(46, 100, 143, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(46, 100, 143, 0.1);
  }

  &:has(input:checked) {
    border-color: var(--bg-plava);
    background: rgba(46, 100, 143, 0.08);
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const PaymentRadio = styled.input`
  width: 1.8rem;
  height: 1.8rem;
  accent-color: var(--bg-plava);
`;

export const PaymentLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--bg-plava);
  cursor: pointer;

  svg {
    font-size: 1.8rem;
    color: var(--bg-plava);
  }
`;

export const OrderSummary = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(46, 100, 143, 0.12);
  border: 1px solid rgba(46, 100, 143, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #ffb74d, #ff8a65);
    border-radius: 20px 20px 0 0;
    z-index: 2;
  }
`;

export const SummaryTitle = styled.h3`
  font-size: 2rem;
  font-weight: 700;
  color: var(--bg-plava);
  margin: 0 0 1rem 0;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(46, 100, 143, 0.1);
`;

export const OrderItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid rgba(46, 100, 143, 0.1);
`;

export const OrderItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  gap: 1rem;
  border-bottom: 1px solid rgba(46, 100, 143, 0.1);
  padding-bottom: 1rem;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
`;

export const ItemTitle = styled.h4`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--bg-plava);

  line-height: 1.3;
`;

export const ItemType = styled.span`
  font-size: 1.2rem;
  color: #666;
`;

export const ItemPrice = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: #ff7043;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const SummaryLabel = styled.span`
  font-size: 1.4rem;
  color: #666;
`;

export const SummaryValue = styled.span`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--bg-plava);
`;

export const TotalRow = styled(SummaryRow)`
  border-top: 1px solid rgba(46, 100, 143, 0.1);
  padding-top: 1rem;
  margin: 2rem 0;

  ${SummaryLabel} {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--bg-plava);
  }

  ${SummaryValue} {
    font-size: 1.8rem;
    font-weight: 800;
    color: #ff7043;
  }
`;
export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DeliveryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;
export const PaddingTop = styled.div`
  padding-top: 2rem;
`;
export const SubtotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ShippingLink = styled.a`
  font-size: 1rem;
  color: var(--bg-plava) !important;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: var(--bg-plava);
  }
`;

export const CheckoutButton = styled.button`
  width: 100%;
  background: rgba(46, 100, 143, 0.08);
  border: 1px solid rgba(46, 100, 143, 0.1);
  color: var(--bg-plava);
  padding: 1.5rem;
  border-radius: 12px;
  font-size: 1.6rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.5s ease;
    z-index: 1;
  }

  &:hover:not(:disabled)::before {
    left: 100%;
  }

  &:hover:not(:disabled) {
    background: rgba(46, 100, 143, 0.12);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(46, 100, 143, 0.2);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 1.2rem;
  font-weight: 500;
  margin-top: 0.5rem;
`;

export const SuccessMessage = styled.div`
  text-align: center;
  background: white;
  padding: 4rem;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(46, 100, 143, 0.12);
  border: 1px solid rgba(46, 100, 143, 0.1);
  position: relative;
  overflow: hidden;
  max-width: 60rem;
  margin: 0 auto;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #10b981, #059669);
    border-radius: 20px 20px 0 0;
  }

  h2 {
    font-size: 2.4rem;
    font-weight: 700;
    color: #10b981;
  }

  p {
    font-size: 1.6rem;
    margin: 0;
  }
`;

export const SuccessContainer = styled.div`
  text-align: center;
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  max-width: none;
  margin: 0;
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(90deg, #10b981, #059669);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem auto;
  animation: pulse 2s infinite;
  box-shadow: 0 8px 20px rgba(46, 100, 143, 0.3);

  svg {
    width: 40px;
    height: 40px;
    color: white;
    stroke-width: 3px;
  }

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
`;

export const SuccessTitle = styled.h2`
  color: var(--bg-plava);
  font-size: 2.8rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  line-height: 1.2;
`;

export const SuccessSubtitle = styled.p`
  color: #666;
  font-size: 1.6rem;
  margin: 0 0 3rem 0;
  line-height: 1.5;
`;

export const InfoGrid = styled.div`
  display: grid;
  gap: 2rem;
  margin: 3rem 0;
  text-align: left;
`;

export const InfoBox = styled.div`
  padding: 2rem;
  background: rgba(46, 100, 143, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(46, 100, 143, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(46, 100, 143, 0.15);
    border-color: rgba(46, 100, 143, 0.2);
  }
`;

export const InfoHeader = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 1rem;
    font-size: 1.8rem;
    color: var(--bg-plava);
  }
`;

export const InfoTitle = styled.strong`
  color: var(--bg-plava);
  font-size: 1.6rem;
  font-weight: 700;
`;

export const InfoText = styled.p`
  margin: 0;
  color: #666;
  font-size: 1.4rem;
  line-height: 1.5;
`;

export const RedirectNotice = styled.div`
  padding: 2rem;
  background: rgba(255, 183, 77, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 183, 77, 0.2);
  margin-top: 3rem;
`;

export const RedirectText = styled.span`
  margin: 0;
  color: #ff7043;
  font-size: 1.4rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  align-self: center;
  justify-self: center;
  max-width: 80%;
  gap: 1rem;

  svg {
    font-size: 1.6rem;
  }
`;

export const ManualRedirectButton = styled.button`
  margin-top: 2rem;
  width: 100%;
  background: rgba(46, 100, 143, 0.08);
  border: 1px solid rgba(46, 100, 143, 0.1);
  color: var(--bg-plava);
  padding: 1.5rem;
  border-radius: 12px;
  font-size: 1.6rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.5s ease;
    z-index: 1;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    background: rgba(46, 100, 143, 0.12);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(46, 100, 143, 0.2);
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  @media (max-width: 420px) {
    position: relative;
  }
`;

export const CheckboxInput = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;

  accent-color: var(--bg-plava);
`;

export const CheckboxLabel = styled.label`
  font-size: 1.4rem;
  color: var(--bg-plava);
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  position: unset;
  white-space: nowrap;
`;

export const TooltipWrapper = styled.div`
  display: flex;
  cursor: pointer;
  position: unset;
  margin-left: auto;
`;

export const TooltipContent = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  background-color: #333;
  color: white;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  max-width: 300px;
  min-width: 300px;
  white-space: normal;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
  }

  ${(props) =>
    !props.$show &&
    `
    visibility: hidden;
    opacity: 0;
  `}

  ${(props) =>
    props.$show &&
    `
    visibility: visible;
    opacity: 1;
  `}

  transition: opacity 0.2s ease, visibility 0.2s ease;

  @media (max-width: 370px) {
    min-width: 250px;
  }
`;
